import Pagination from "../PaginationComponent/Pagination";
import DeviceService from "../../Services/DeviceService";
import Popup from "../PopupComponent/Popup";
import { ReactComponent as BulkEdit } from '../../Assets/img/Editprimary.svg';
import { ReactComponent as Delete } from '../../Assets/img/Deleteprimary.svg';
import { useState } from "react";

function Footer(props) {

    return (
        <div className="footer-container">
            <div className="footer-buttons-container">
                {props.disableEditButton == null &&
                    <button disabled={props.selectedItems === 0} className="thirds-button" onClick={() => props.modelOpenHandler("bulkedit")}>
                        <span className="thirds-button-icon"><BulkEdit /></span>
                        <span className="thirds-button-text">Edit All</span>
                    </button>}
                {props.disableLine == null &&
                    <span style={{ borderRight: "1px solid #0000001F", marginRight: "1%" }}></span>}
                {props.disableDeleteButton == null &&
                    <button disabled={props.selectedItems === 0} className="thirds-button" onClick={() => props.modelOpenHandler("delete")}>
                        <span className="thirds-button-icon"><Delete /></span>
                        <span className="thirds-button-text">Delete</span>
                    </button>}
            </div>
            <div className="footer-center">
                {props.selectedItems} Item{props.selectedItems == 1 ? '' : 's'} selected
            </div>
            <Pagination onFirstClick={props.onFirstClick} onLastClick={props.onLastClick} onPreviousClick={props.onPreviousClick} onNextClick={props.onNextClick} perPage={props.perPage} totalData={props.totalData} showingItemsCount={props.showingItemsCount} currentPage={props.currentPage} totalPage={props.totalPage} changePerPage={props.changePerPage} />
        </div>
    );
}

export default Footer;